type EmptyStateProps = {
  title: string;
  detail?: string;
  action?: React.ReactNode;
};

export function EmptyState({ title, detail, action }: EmptyStateProps) {
  return (
    <div className="staff-empty">
      <h3 className="staff-empty__title">{title}</h3>
      {detail ? <p className="staff-empty__detail muted">{detail}</p> : null}
      {action ? <div className="staff-empty__action">{action}</div> : null}
    </div>
  );
}
